// extracted by mini-css-extract-plugin
module.exports = {"survey-header":"survey-header___jZG7","logo":"logo__18XQ4","survey-name":"survey-name__3bgmQ","survey-description":"survey-description__1OLGQ"};